/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DataImportTagResponse
 */
export interface DataImportTagResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof DataImportTagResponse
     */
    tags: Array<string>;
}

/**
 * Check if a given object implements the DataImportTagResponse interface.
 */
export function instanceOfDataImportTagResponse(value: object): value is DataImportTagResponse {
    if (!('tags' in value) || value['tags'] === undefined) return false;
    return true;
}

export function DataImportTagResponseFromJSON(json: any): DataImportTagResponse {
    return DataImportTagResponseFromJSONTyped(json, false);
}

export function DataImportTagResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DataImportTagResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'tags': json['tags'],
    };
}

export function DataImportTagResponseToJSON(value?: DataImportTagResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'tags': value['tags'],
    };
}

